/**
 * Different drag and drop overlay modes of UploadCollection.
 * @private
 */
enum UploadCollectionDnDOverlayMode {
	/**
	 * No drag or drop indication.
	 * @private
	 */
	None = "None",

	/**
	 * Indication that drag can be performed.
	 * @private
	 */
	Drag = "Drag",

	/**
	 * Indication that drop can be performed.
	 * @private
	 */
	Drop = "Drop",
}

export default UploadCollectionDnDOverlayMode;
